module.exports = __webpack_public_path__ + "static/media/permissions2.55df7e34.jpg";